"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var D = __importStar(require("../../data"));
var SimpleUI = __importStar(require("../../simple-ui"));
var Data = __importStar(require("../interface/user-management/profile/data"));
var ProfilePage = function (_a) {
    var data = _a.data, withBackend = _a.withBackend;
    return (react_1["default"].createElement(SimpleUI.ProfilePage, { data: data, updateProfilePromise: Data.update(withBackend), updatePasswordPromise: Data.passwordUpdate(withBackend) }));
};
var ProfilePageLoader = function (_a) {
    var withBackend = _a.withBackend;
    return (react_1["default"].createElement(D.Load.WithLoader, { dataLoad: Data.detail(withBackend), Component: ProfilePage, withBackend: withBackend }));
};
exports["default"] = ProfilePageLoader;
